import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { Texture } from './Texture.js';
import { NearestFilter } from '../constants.js';

var DataTexture = /*#__PURE__*/function (_Texture) {
  _inheritsLoose(DataTexture, _Texture);

  function DataTexture(data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    var _this;

    if (data === void 0) {
      data = null;
    }

    if (width === void 0) {
      width = 1;
    }

    if (height === void 0) {
      height = 1;
    }

    if (magFilter === void 0) {
      magFilter = NearestFilter;
    }

    if (minFilter === void 0) {
      minFilter = NearestFilter;
    }

    _this = _Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) || this;
    _this.image = {
      data: data,
      width: width,
      height: height
    };
    _this.magFilter = magFilter;
    _this.minFilter = minFilter;
    _this.generateMipmaps = false;
    _this.flipY = false;
    _this.unpackAlignment = 1;
    _this.needsUpdate = true;
    return _this;
  }

  return DataTexture;
}(Texture);

DataTexture.prototype.isDataTexture = true;
export { DataTexture };